<template>
  <v-container v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-form ref="form" validation @input="checkValidate" class="ml-3">
      <v-layout row>
        <v-flex xs12 lg12 md12>
          <h1 class="my-3">{{title}}</h1>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12 lg8 md8>
          <v-text-field
              label="Наименование ограничения"
              v-model="restrictionTitle"
              :rules="restrictionTitleRules"
              validate-on-blur
              outline
          ></v-text-field>
        </v-flex>
      </v-layout>

      <p class="title">Каналы продаж</p>
      <v-layout
          v-if="channelList.length > 0"
          class="mb-4"
      >
        <v-flex xs12 lg8 md8 pa-3 class="elevation-1 white">
          <div
              v-for="(channel, index) in channelList"
              :key="channel.id"
          >
            <v-checkbox
                :label="channel.title"
                v-model="channelList[index].checked"
                class="ma-0 pa-0"
            ></v-checkbox>
          </div>
        </v-flex>
      </v-layout>

      <p class="title">Торговые точки</p>
      <v-layout row v-if="pointTreeData.length > 0" class="mb-4">
        <v-flex xs12 lg8 md8 pa-3 class="elevation-1 white">
          <v-text-field
              label="Поиск"
              v-model="pointSearch"
              outline
          ></v-text-field>
          <v-progress-circular
              v-if="pointLoading"
              :size="50"
              color="primary"
              indeterminate
          ></v-progress-circular>
          <div v-if="pointSearchTree.length > 0 && !pointLoading">
            <tree
                :data="pointSearchTree"
                :options="{
              checkbox: true,
              fetchData(node) {
                if (node.children.length > 0) {
                  return blank()
                } else {
                  return getPointFolder(node.data.id)
                }
              },
              treeType: 'pointTree'
            }"
                class="tree--small"
                @node:checked="onPointChecked"
                @node:unchecked="onPointUnchecked"
            />
          </div>
          <div v-else>
            <div v-if="pointTreeData.length > 0 && !pointLoading">
              <tree
                  :data="pointTreeData"
                  :options="{
                checkbox: true,
                fetchData(node) {
                  if (node.children.length > 0) {
                    return blank()
                  } else {
                    return getPointFolder(node.data.id)
                  }
                },
                treeType: 'pointTree'
              }"
                  class="tree--small"
                  @node:checked="onPointChecked"
                  @node:unchecked="onPointUnchecked"
              />
            </div>
          </div>
        </v-flex>
      </v-layout>

      <p class="title">Товары</p>
      <v-layout row>
        <v-flex xs12 lg8 md8 pa-3 class="elevation-1 white">
          <v-progress-circular
              v-if="productLoading"
              :size="50"
              color="primary"
              indeterminate
          ></v-progress-circular>
          <div v-if="productTreeData.length > 0 && !productLoading">
            <tree
                :data="productTreeData"
                :options="{
                checkbox: true,
                fetchData(node) {
                  if (node.data.type === 'category') {
                    if (node.children.length > 0) {
                      return blank()
                    } else {
                      return getProductBrand(node.data.id, node.state.checked)
                    }
                  } else if (node.data.type === 'brand') {
                    if (node.children.length > 0) {
                      return blank()
                    } else {
                      return getProductSku(node.data.id, node.state.checked)
                    }
                  }
                },
                treeType: 'productTree'
              }"
                class="tree--small"
                @node:checked="onProductChecked"
                @node:unchecked="onProductUnchecked"
            />
          </div>
        </v-flex>
      </v-layout>

      <v-layout row class="pa-0 mt-3 mb-3">
        <v-flex xs12 lg12 md12>
          <div class="float-left inline-block">
            <p class="title">Дата начала</p>
            <v-date-picker
                v-model="startDate"
                :reactive="true"
                locale="ru"
                class="mr-3 ml-0 mt-0 mb-3"
                :min="minDate()"
                @input="checkValidate()"
                :first-day-of-week="1"
            ></v-date-picker>
          </div>
          <div class="inline-block">
            <p class="title">Дата окончания</p>
            <v-date-picker
                v-model="endDate"
                :reactive="true"
                locale="ru"
                class="mr-3 ml-0"
                :min="minDate()"
                @input="checkValidate()"
                :first-day-of-week="1"
            ></v-date-picker>
          </div>
        </v-flex>
      </v-layout>

      <v-layout row class="pa-0 ma-0">
        <v-flex xs12 lg6 md6>
          <v-btn
              :loading="loading"
              :disabled="!valid || loading"
              color="primary"
              @click.native="loader = 'loading'"
              class="ma-0"
              @click="onClickCreateRestriction"
          >
            {{id === null ? 'Создать' : 'Изменить'}}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      breadcrumbs: [
        {name: 'Главная', link: '/'},
        {name: 'Ограничения', link: '/restrictions/active'}
      ],
      pageDataReady: {
        isReady: false,
        distributionChannelList: false,
        points: false,
        products: false
      },
      channelIdList: [],
      channelList: [],
      pointListTreeData: [],
      pointFolderIdList: [],
      pointIdList: [],
      pointTreeData: [],
      pointTreeIdCounter: 0,
      pointLoading: false,
      pointSearch: '',
      pointSearchTimer: null,
      pointSearchTree: [],

      productListTreeData: [],
      productCategoryIdList: [],
      productBrandIdList: [],
      productIdList: [],
      productTreeData: [],
      productTreeIdCounter: 0,
      productLoading: false,

      id: null,
      title: 'Новое ограничение',
      restrictionTitle: null,
      startDate: null,
      endDate: null,
      valid: false,
      restrictionTitleRules: [
        v => !!v || 'Обязательное поле'
      ]
    }),
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.distributionChannelList) {
          return false
        }
        if (!this.pageDataReady.points) {
          return false
        }
        if (!this.pageDataReady.products) {
          return false
        }

        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      onPointChecked (node) {
        if (node.data.type === 'folder' && !~this.pointFolderIdList.indexOf(node.data.id)) {
          this.pointFolderIdList.push(node.data.id)
        }
        if (node.data.type === 'point' && !~this.pointIdList.indexOf(node.data.id)) {
          this.pointIdList.push(node.data.id)
        }
      },
      onPointUnchecked (node) {
        if (node.data.type === 'folder') {
          let position = this.pointFolderIdList.indexOf(node.data.id)
          if (~position) this.pointFolderIdList.splice(position, 1)
          for (let i = 0; i < node.children.length; i++) {
            if (node.children[i].states.checked) {
              if (node.children[i].data.type === 'folder') {
                let position = this.pointFolderIdList.indexOf(node.children[i].data.id)
                if (!~position) this.pointFolderIdList.push(node.children[i].data.id)
              }
              if (node.children[i].data.type === 'point') {
                let position = this.pointIdList.indexOf(node.children[i].data.id)
                if (!~position) this.pointIdList.push(node.children[i].data.id)
              }
            }
          }
        }
        if (node.data.type === 'point') {
          let position = this.pointIdList.indexOf(node.data.id)
          if (~position) this.pointIdList.splice(position, 1)
        }
      },
      onProductChecked (node) {
        if (node.data.type === 'category' && !~this.productCategoryIdList.indexOf(node.data.id)) {
          this.productCategoryIdList.push(node.data.id)
        }
        if (node.data.type === 'brand' && !~this.productBrandIdList.indexOf(node.data.id)) {
          this.productBrandIdList.push(node.data.id)
        }
        if (node.data.type === 'sku' && !~this.productIdList.indexOf(node.data.id)) {
          this.productIdList.push(node.data.id)
        }
      },
      onProductUnchecked (node) {
        if (node.data.type === 'category') {
          let position = this.productCategoryIdList.indexOf(node.data.id)
          if (~position) this.productCategoryIdList.splice(position, 1)
          for (let i = 0; i < node.children.length; i++) {
            if (node.children[i].states.checked) {
              let position = this.productBrandIdList.indexOf(node.children[i].data.id)
              if (!~position) this.productBrandIdList.push(node.children[i].data.id)
            }
          }
        }
        if (node.data.type === 'brand') {
          let position = this.productBrandIdList.indexOf(node.data.id)
          if (~position) this.productBrandIdList.splice(position, 1)
          for (let i = 0; i < node.children.length; i++) {
            if (node.children[i].states.checked) {
              let position = this.productIdList.indexOf(node.children[i].data.id)
              if (!~position) this.productIdList.push(node.children[i].data.id)
            }
          }
        }
        if (node.data.type === 'sku') {
          let position = this.productIdList.indexOf(node.data.id)
          if (~position) this.productIdList.splice(position, 1)
        }
      },
      async onClickCreateRestriction () {
        let pointTree = null
        let productTree = null
        for (let i = 0; i < this.$refs.form.$children.length; i++) {
          if (typeof this.$refs.form.$children[i].tree !== 'undefined') {
            if (this.$refs.form.$children[i].options.treeType === 'pointTree') {
              pointTree = this.$refs.form.$children[i].model
            }
            if (this.$refs.form.$children[i].options.treeType === 'productTree') {
              productTree = this.$refs.form.$children[i].model
            }
          }
        }

        this.filterChildrenProductIdList(productTree)
        this.filterChildrenPointIdList(pointTree)

        let restrictionData = {
          id: this.id,
          title: this.restrictionTitle,
          startDate: this.startDate + ' 00:00:00',
          endDate: this.endDate + ' 00:00:00'
        }

        if (this.pointFolderIdList.length > 0) {
          restrictionData.pointFolderIdList = this.pointFolderIdList
        }
        if (this.pointIdList.length > 0) {
          restrictionData.pointIdList = this.pointIdList
        }
        if (this.productCategoryIdList.length > 0) {
          restrictionData.productCategoryIdList = this.productCategoryIdList
        }
        if (this.productBrandIdList.length > 0) {
          restrictionData.productBrandIdList = this.productBrandIdList
        }
        if (this.productIdList.length > 0) {
          restrictionData.productIdList = this.productIdList
        }

        this.channelIdList = []
        for (let i = 0; i < this.channelList.length; i++) {
          if (this.channelList[i].checked) {
            this.channelIdList.push(this.channelList[i].id)
          }
        }

        if (this.channelIdList.length > 0) {
          restrictionData.channelIdList = this.channelIdList
        }

        await this.$store.dispatch('createRestriction', restrictionData)
          .then((data) => {
            if (typeof data.restrict !== 'undefined') {
              this.$router.push('/restrictions/single/' + data.restrict.id)
            }
          })
          .catch(() => {})
      },
      minDate () {
        let date = new Date()
        date.setHours(24)
        return this.$moment(date).format('YYYY-MM-DD')
      },
      checkValidate () {
        if (this.startDate === null) {
          this.valid = false
        } else if (this.endDate === null) {
          this.valid = false
        } else if (this.restrictionTitle === null || this.restrictionTitle === '') {
          this.valid = false
        } else {
          this.valid = true
        }
        return this.valid
      },
      onCreated () {
        this.$store.commit('setPageLoading', true)

        this.id = null
        this.restrictionTitle = null
        this.startDate = null
        this.endDate = null
        this.channelIdList = []
        this.channelList = []
        this.pointListTreeData = []
        this.pointFolderIdList = []
        this.pointIdList = []
        this.pointTreeData = []
        this.pointTreeIdCounter = 0
        this.productListTreeData = []
        this.productCategoryIdList = []
        this.productBrandIdList = []
        this.productIdList = []
        this.productTreeData = []
        this.productTreeIdCounter = 0
        this.pointSearch = ''
        this.pointSearchTimer = null
        this.pointSearchTree = []

        this.breadcrumbs = [
          {name: 'Главная', link: '/'},
          {name: 'Ограничения', link: '/restrictions/active'}
        ]

        if (this.$router.currentRoute.path.indexOf('/restrictions/edit/') !== -1) {
          this.id = parseInt(this.$route.params.id)
          this.title = 'Редактировать ограничение'
          this.$store.dispatch('getRestrictionSingle', {id: this.id})
          this.breadcrumbs.push({name: 'Редактировать ограничение'})
        } else {
          this.id = null
          this.title = 'Новое ограничение'
          this.breadcrumbs.push({name: 'Новое ограничение'})

          this.$store.dispatch('getDistributionChannelList')
            .then(() => {
              this.pageDataReady.distributionChannelList = true
              this.pageDataStatus()
            })
          // this.$store.dispatch('getProductList')
          // this.$store.dispatch('getPointList')
          this.getPointFolder(0)
            .then((data) => {
              this.pointTreeData = data
              this.pageDataReady.points = true
              this.pageDataStatus()
            })
            .catch(() => {})

          this.getProductCategory()
            .then((data) => {
              this.productTreeData = data
              this.pageDataReady.products = true
              this.pageDataStatus()
            })
            .catch(() => {})
        }
        this.$store.commit('setPageTitle', this.title)
      },
      async getPointFolder (nodeId) {
        let folder
        await this.$store.dispatch('getPointFolderList', {id: nodeId, mode: 'active'})
          .then((data) => {
            if (this.id !== null && this.restriction !== null) {
              folder = this.pointTreeDataStructure([data], false, this.restriction.point_folder_tree)[0].children
            } else {
              folder = this.pointTreeDataStructure([data])[0].children
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return folder
      },
      async getProductCategory () {
        let categoryList = []
        await this.$store.dispatch('getProductCategoryList')
          .then((data) => {
            for (let i = 0; i < data.product_category_list.length; i++) {
              categoryList[i] = {
                text: data.product_category_list[i].title,
                data: {
                  id: data.product_category_list[i].id,
                  type: 'category'
                },
                id: this.productTreeIdCounter++,
                isBatch: true,
                state: {}
              }

              let productCategoryIdPosition = this.productCategoryIdList.indexOf(data.product_category_list[i].id)
              let categoryChecked = false
              if (~productCategoryIdPosition) {
                categoryChecked = true
              } else {
                if (this.id !== null) {
                  for (let k = 0; k < this.restriction.product_category_tree.length; k++) {
                    let isId = this.restriction.product_category_tree[k].id === data.product_category_list[i].id
                    if (isId && this.restriction.product_category_tree[k].product_brand_list.length > 0) {
                      categoryList[i].state.indeterminate = true
                    }
                  }
                }
              }
              categoryList[i].state.checked = categoryChecked
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return categoryList
      },
      async getProductBrand (categoryId, categoryChecked) {
        let brandList = []
        await this.$store.dispatch('getProductBrandList', {id: categoryId})
          .then((data) => {
            for (let i = 0; i < data.product_category_brand_list.length; i++) {
              brandList[i] = {
                text: data.product_category_brand_list[i].title,
                data: {
                  id: data.product_category_brand_list[i].id,
                  productBrandId: data.product_category_brand_list[i].product_brand_id,
                  type: 'brand'
                },
                id: this.productTreeIdCounter++,
                isBatch: true,
                state: {}
              }

              let productBrandIdPosition = this.productBrandIdList.indexOf(data.product_category_brand_list[i].id)
              let brandChecked = false
              if (~productBrandIdPosition || categoryChecked) {
                brandChecked = true
              } else {
                if (this.id !== null) {
                  for (let j = 0; j < this.restriction.product_category_tree.length; j++) {
                    for (let k = 0; k < this.restriction.product_category_tree[j].product_brand_list.length; k++) {
                      let isId = this.restriction.product_category_tree[j].product_brand_list[k].id === data.product_category_brand_list[i].id
                      if (isId && this.restriction.product_category_tree[j].product_brand_list[k].product_sku_list.length > 0) {
                        brandList[i].state.indeterminate = true
                      }
                    }
                  }
                }
              }
              brandList[i].state.checked = brandChecked
            }
          })
          .catch(() => {})
        return brandList
      },
      async getProductSku (brandId, brandChecked) {
        let skuList = []
        await this.$store.dispatch('getProductSkuList', {id: brandId})
          .then((data) => {
            for (let i = 0; i < data.product_sku_list.length; i++) {
              skuList[i] = {
                text: data.product_sku_list[i].title,
                data: {
                  id: data.product_sku_list[i].id,
                  type: 'sku'
                },
                id: this.productTreeIdCounter++,
                isBatch: false,
                state: {}
              }

              let productIdPosition = this.productIdList.indexOf(data.product_sku_list[i].id)
              let productChecked = false
              if (brandChecked || ~productIdPosition) {
                productChecked = true
              }
              skuList[i].state.checked = productChecked
            }
          })
          .catch(() => {})
        return skuList
      },
      isChildrenInPointTree (id, tree) {
        if (tree !== null && typeof tree !== 'undefined') {
          for (let i = 0; i < tree.length; i++) {
            let isId = tree[i].id === id
            let isFolders = typeof tree[i].point_folder_list !== 'undefined' ? tree[i].point_folder_list.length > 0 : false
            let isPoints = typeof tree[i].point_list !== 'undefined' ? tree[i].point_list.length > 0 : false

            if (isId && (isFolders || isPoints)) {
              return true
            } else if (isFolders) {
              if (this.isChildrenInPointTree(id, tree[i].point_folder_list)) {
                return true
              }
            }
          }
        }
        return false
      },
      pointTreeDataStructure (pointFolderList, folderChecked = false, indeterminateTree = null) {
        let resultList = []

        for (let i = 0; i < pointFolderList.length; i++) {
          resultList[i] = {}

          if (typeof pointFolderList[i].title !== 'undefined') {
            resultList[i].text = pointFolderList[i].title
          }

          if (typeof pointFolderList[i].id !== 'undefined') {
            resultList[i].data = {
              id: pointFolderList[i].id,
              type: 'folder'
            }
            resultList[i].id = this.pointTreeIdCounter++
            resultList[i].isBatch = pointFolderList[i].have_children
          }

          let folderIdPosition = this.pointFolderIdList.indexOf(pointFolderList[i].id)
          let currentFolderChecked = false
          if (~folderIdPosition || folderChecked) {
            currentFolderChecked = true
          }
          resultList[i].state = { checked: currentFolderChecked }

          if (!currentFolderChecked && indeterminateTree !== null) {
            resultList[i].state.indeterminate = this.isChildrenInPointTree(pointFolderList[i].id, indeterminateTree)
            resultList[i].state.expanded = this.isChildrenInPointTree(pointFolderList[i].id, indeterminateTree)
          }

          if (typeof pointFolderList[i].point_folder_list !== 'undefined') {
            resultList[i].children = []
            resultList[i].children = this.pointTreeDataStructure(pointFolderList[i].point_folder_list, folderChecked, indeterminateTree)
          }

          if (typeof pointFolderList[i].point_list !== 'undefined') {
            if (typeof resultList[i].children === 'undefined') {
              resultList[i].children = []
            }

            for (let j = 0; j < pointFolderList[i].point_list.length; j++) {
              let index = resultList[i].children.length
              resultList[i].children[index] = {
                text: pointFolderList[i].point_list[j].title,
                data: {
                  id: pointFolderList[i].point_list[j].id,
                  type: 'point'
                }
              }
              let pointIdPosition = this.pointIdList.indexOf(pointFolderList[i].point_list[j].id)
              let pointChecked = false
              if (~pointIdPosition || currentFolderChecked) {
                pointChecked = true
              }
              resultList[i].children[index].state = { checked: pointChecked }
            }
          }
        }
        return resultList
      },
      productTreeDataStructure (productCategoryList) {
        let resultList = []

        for (let i = 0; i < productCategoryList.length; i++) {
          resultList[i] = {
            text: productCategoryList[i].title,
            data: {
              id: productCategoryList[i].id,
              type: 'category'
            }
          }

          let productCategoryIdPosition = this.productCategoryIdList.indexOf(productCategoryList[i].id)
          let categoryChecked = false
          if (~productCategoryIdPosition) {
            categoryChecked = true
          }
          resultList[i].state = { checked: categoryChecked }

          resultList[i].children = []
          for (let j = 0; j < productCategoryList[i].product_brand_list.length; j++) {
            resultList[i].children[j] = {
              text: productCategoryList[i].product_brand_list[j].title,
              data: {
                id: productCategoryList[i].product_brand_list[j].id,
                productBrandId: productCategoryList[i].product_brand_list[j].product_brand_id,
                type: 'brand'
              }
            }

            let productBrandIdPosition = this.productBrandIdList.indexOf(productCategoryList[i].product_brand_list[j].id)
            let brandChecked = false
            if (~productBrandIdPosition || categoryChecked) {
              brandChecked = true
            }
            resultList[i].children[j].state = { checked: brandChecked }

            resultList[i].children[j].children = []
            for (let k = 0; k < productCategoryList[i].product_brand_list[j].product_sku_list.length; k++) {
              resultList[i].children[j].children[k] = {
                text: productCategoryList[i].product_brand_list[j].product_sku_list[k].title,
                data: {
                  id: productCategoryList[i].product_brand_list[j].product_sku_list[k].id,
                  productBrandId: productCategoryList[i].product_brand_list[j].product_brand_id,
                  type: 'sku'
                }
              }

              let productIdPosition = this.productIdList.indexOf(productCategoryList[i].product_brand_list[j].product_sku_list[k].id)
              let productChecked = false
              if (brandChecked || ~productIdPosition) {
                productChecked = true
              }
              resultList[i].children[j].children[k].state = { checked: productChecked }
            }
          }
        }
        return resultList
      },
      filterChildrenProductIdList (tree) {
        for (let i = 0; i < tree.length; i++) {
          let brandDelete = false
          let categoryPosition = this.productCategoryIdList.indexOf(tree[i].data.id)
          if (~categoryPosition) {
            brandDelete = true
          }
          for (let j = 0; j < tree[i].children.length; j++) {
            let skuDelete = false
            let brandPosition = this.productBrandIdList.indexOf(tree[i].children[j].data.id)
            if (~brandPosition) {
              skuDelete = true
            }
            for (let k = 0; k < tree[i].children[j].children.length; k++) {
              let skuPosition = this.productIdList.indexOf(tree[i].children[j].children[k].data.id)
              if (skuDelete && ~skuPosition) {
                this.productIdList.splice(skuPosition, 1)
              }
            }
            if (brandDelete && ~brandPosition) {
              this.productBrandIdList.splice(brandPosition, 1)
            }
          }
        }
      },
      filterChildrenPointIdList (tree, deleteThis = false) {
        for (let i = 0; i < tree.length; i++) {
          if (tree[i].data.type === 'folder') {
            let folderIdPosition = this.pointFolderIdList.indexOf(tree[i].data.id)
            if (~folderIdPosition) {
              if (deleteThis) {
                this.pointFolderIdList.splice(folderIdPosition, 1)
              }
              this.filterChildrenPointIdList(tree[i].children, true)
            } else {
              if (deleteThis) {
                this.filterChildrenPointIdList(tree[i].children, true)
              } else {
                this.filterChildrenPointIdList(tree[i].children, false)
              }
            }
          } else if (tree[i].data.type === 'point') {
            let pointIdPosition = this.pointIdList.indexOf(tree[i].data.id)
            if (~pointIdPosition && deleteThis) {
              this.pointIdList.splice(pointIdPosition, 1)
            }
          }
        }
      },
      async pointTreeLoader (id = 0) {
        this.pointLoading = true
        let pointTreeData = await this.$store.dispatch('getPointFolderList', {id: id, mode: 'active'})
          .then((data) => {
            return data
          })
          .catch((e) => {
            console.log(e)
          })

        if (typeof pointTreeData.point_folder_list !== 'undefined') {
          for (let i = 0; i < pointTreeData.point_folder_list.length; i++) {
            if (this.isChildrenInPointTree(pointTreeData.point_folder_list[i].id, this.restriction.point_folder_tree)) {
              let child = await this.pointTreeLoader(pointTreeData.point_folder_list[i].id)
              pointTreeData.point_folder_list[i].point_folder_list = child.point_folder_list
              pointTreeData.point_folder_list[i].point_list = child.point_list
            }
          }
        }

        if (id === 0) {
          this.pointTreeData = this.pointTreeDataStructure([pointTreeData], false, this.restriction.point_folder_tree)[0].children
          this.pointLoading = false
          this.pageDataReady.points = true
          this.pageDataStatus()
        } else {
          return pointTreeData
        }
      },
      async productTreeLoader (id = 0) {
        let productTreeData = await this.getProductCategory()
          .then((data) => {
            return data
          })
          .catch(() => {})

        for (let i = 0; i < productTreeData.length; i++) {
          if (productTreeData[i].state.indeterminate) {
            productTreeData[i].state.expanded = true
            productTreeData[i].children = await this.getProductBrand(productTreeData[i].data.id, productTreeData[i].state.checked)
              .then((data) => {
                return data
              })
              .catch(() => {})

            for (let k = 0; k < productTreeData[i].children.length; k++) {
              if (productTreeData[i].children[k].state.indeterminate) {
                productTreeData[i].children[k].state.expanded = true
                productTreeData[i].children[k].children = await this.getProductSku(productTreeData[i].children[k].data.id, productTreeData[i].children[k].state.checked)
                  .then((data) => {
                    return data
                  })
                  .catch(() => {
                  })
              }
            }
          }
        }
        this.productTreeData = productTreeData
        this.pageDataReady.products = true
        this.pageDataStatus()
      },
      async blank () {
        return []
      }
    },
    computed: {
      loading () {
        return this.$store.getters.loading
      },
      restriction () {
        return this.$store.getters.restrictionSingle
      },
      distributionChannelList () {
        return this.$store.getters.distributionChannelList
      },
      productList () {
        return this.$store.getters.productList
      },
      pointTree () {
        return this.$store.getters.pointTree
      }
    },
    created () {
      this.onCreated()
    },
    watch: {
      '$route' (to, from) {
        this.onCreated()
      },
      restriction (newRestriction, oldRestriction) {
        if (this.restriction !== null && this.restriction !== undefined) {
          this.restrictionTitle = this.restriction.title
          this.startDate = this.$moment(this.restriction.start_date).format('YYYY-MM-DD')
          this.endDate = this.$moment(this.restriction.end_date).format('YYYY-MM-DD')

          if (typeof this.restriction.distribution_channel_list !== 'undefined') {
            this.channelIdList = []
            for (let i = 0; i < this.restriction.distribution_channel_list.length; i++) {
              this.channelIdList.push(this.restriction.distribution_channel_list[i].id)
            }
          }

          if (typeof this.restriction.point_folder_list !== 'undefined') {
            this.pointFolderIdList = []
            for (let i = 0; i < this.restriction.point_folder_list.length; i++) {
              this.pointFolderIdList.push(this.restriction.point_folder_list[i].id)
            }
          }

          if (typeof this.restriction.point_list !== 'undefined') {
            this.pointIdList = []
            for (let i = 0; i < this.restriction.point_list.length; i++) {
              this.pointIdList.push(this.restriction.point_list[i].id)
            }
          }

          if (typeof this.restriction.product_category_list !== 'undefined') {
            this.productCategoryIdList = []
            for (let i = 0; i < this.restriction.product_category_list.length; i++) {
              this.productCategoryIdList.push(this.restriction.product_category_list[i].id)
            }
          }

          if (typeof this.restriction.product_category_brand_list !== 'undefined') {
            this.productBrandIdList = []
            for (let i = 0; i < this.restriction.product_category_brand_list.length; i++) {
              this.productBrandIdList.push(this.restriction.product_category_brand_list[i].id)
            }
          }

          if (typeof this.restriction.product_sku_list !== 'undefined') {
            this.productIdList = []
            for (let i = 0; i < this.restriction.product_sku_list.length; i++) {
              this.productIdList.push(this.restriction.product_sku_list[i].id)
            }
          }

          this.$store.dispatch('getDistributionChannelList')
            .then(() => {
              this.pageDataReady.distributionChannelList = true
              this.pageDataStatus()
            })
          this.pointTreeLoader()

          this.productTreeLoader()
        }
      },
      productList (n, o) {
        this.productListTreeData = this.productTreeDataStructure(this.productList)
      },
      distributionChannelList (n, o) {
        this.channelList = []
        for (let i = 0; i < this.distributionChannelList.length; i++) {
          this.channelList[i] = this.distributionChannelList[i]
        }

        if (this.channelIdList.length > 0) {
          for (let i = 0; i < this.channelList.length; i++) {
            let position = this.channelIdList.indexOf(this.channelList[i].id)
            if (~position) {
              this.channelList[i].checked = true
            } else {
              this.channelList[i].checked = false
            }
          }
        }
      },
      pointSearch (val) {
        if (this.pointSearchTimer !== null) {
          clearTimeout(this.pointSearchTimer)
        }

        this.pointLoading = true
        let _this = this
        if (this.pointSearch.length >= 5) {
          this.pointSearchTimer = setTimeout(function () {
            _this.$store.dispatch('getPointTree', {q: _this.pointSearch})
          }, 1000)
        } else {
          this.pointSearchTimer = setTimeout(function () {
            this.pointLoading = false
            _this.$store.commit('setPointTree', [])
          }, 1000)
        }
      },
      pointTree (val) {
        this.pointLoading = false
        this.pointSearchTree = this.pointTreeDataStructure(this.pointTree)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Restrictions/RestrictionNew.vue